module.exports = __webpack_public_path__ + "img/pers-appartement-exterieurs.ec2d2e23.jpg";